export default function getResource(label, vars = []) {
    const resources = {
        accessibilityOtpLegend: `Saisissez le code à ${vars[0]} chiffres envoyé à votre adresse courriel`,
        accessibilityOtpInput: `Saisie du code de vérification ${vars[0]}`
    };

    return resources[label];
}
